// extracted by mini-css-extract-plugin
module.exports = {"fullPageErrorContainer":"FullPageError_fullPageErrorContainer__2dxqd"};